import { configureStore } from "@reduxjs/toolkit";
import { composeWithDevTools } from "@redux-devtools/extension";
import {
	persistStore,
	persistReducer,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import appReducer from "./reducers";

const storageKey = process.env.REACT_APP_STORAGE_KEY;

const initialState = {};

const persistConfig = {
	key: storageKey,
	storage,
	whitelist: ["auth", "forgotPassword"],
	blacklist: ["nav"],
};

const persistedReducer = persistReducer(persistConfig, appReducer);

const AppStore = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}),
	devTools: composeWithDevTools({
		name: "rbetrajV2",
		trace: true,
		traceLimit: 25,
	}),
	preloadedState: initialState,
});

let persistor = persistStore(AppStore);

export { AppStore, persistor };
